import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { hostApi } from "@/lib/api";

const CONSOLE_URL = (process.env.REACT_APP_CONSOLE_URL || "https://console.stayeasy.io").replace(/\/$/, "");

export default function HostSubscriptionConfirmed() {
  const [params] = useSearchParams();
  const [state, setState] = useState("confirming");
  const [message, setMessage] = useState("Confirming your host subscription…");

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState("error");
      setMessage("Stripe checkout session is missing.");
      return;
    }
    (async () => {
      try {
        await hostApi.confirmSubscription(sessionId);
        setState("success");
        setMessage("Your host subscription is active.");
      } catch (err) {
        setState("error");
        setMessage(err?.apiMessage || err?.response?.data?.message || "Subscription confirmation is still processing. Continue in the host console to refresh or retry.");
      }
    })();
  }, [params]);

  return (
    <main className="mx-auto max-w-3xl px-5 py-24 text-center md:px-10 md:py-32">
      {state === "success" && <CheckCircle2 size={42} className="mx-auto text-primary" />}
      <h1 className="mt-5 font-display text-5xl font-medium tracking-tight">{state === "success" ? "Subscription confirmed." : state === "error" ? "Confirmation pending." : "One moment."}</h1>
      <p className="mx-auto mt-5 max-w-xl text-muted-foreground">{message}</p>
      <div className="mt-8 flex justify-center gap-3">
        <a href={`${CONSOLE_URL}${state === "success" ? "/host/profile" : "/host/subscription"}`} className="rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground">
          {state === "success" ? "Continue host setup" : "Open host console"}
        </a>
      </div>
    </main>
  );
}
